module.exports = __webpack_public_path__ + "img/user.a8048ae4.svg";